export default __webpack_public_path__ + "static/media/Advanced Potion Making - Spells_04.bd8308d9.jpg";